import styled from "styled-components";

export const DrillBox = styled.div`
  margin: 0.5rem 0;
  padding: 1rem 1.25rem;
  min-width: 16rem;
  max-width: 22rem;
  text-align: center;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 1rem;
  line-height: 1.6;
  /* Theme from the CSS \`data-theme\` attribute (set on <html> by the inline
     theme script, reliable even on this pre-hydration loading screen), NOT a JS
     isDark flag: LoadingAnimation renders outside the ThemeContext provider, so
     the flag came through false on a dark screen and left the card text #222 on
     navy — unreadable. Same signal the muted dots use in LoadingAnimation.sc. */
  color: #222;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
  cursor: pointer;
  user-select: none;

  :root[data-theme="dark"] & {
    color: #f0f0f0;
    border-color: rgba(255, 255, 255, 0.25);
  }
`;

export const DrillHint = styled.div`
  font-size: 0.75em;
  opacity: 0.5;
  margin-top: 0.5rem;
`;

export const DrillAnswer = styled.span`
  opacity: ${({ $revealed }) => ($revealed ? 1 : 0.35)};
`;

// Peripheral exit: separated from history by an extra margin so it reads
// as a meta-action, not another history line. Stays in-flow because
// LoadingAnimation's parent tree includes a transform somewhere that
// would break position:fixed.
export const DrillExitLink = styled.button`
  margin-top: 2rem;
  background: transparent;
  border: 0;
  color: inherit;
  opacity: 0.55;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.8em;
  text-decoration: underline;
  text-underline-offset: 0.2em;
  &:hover { opacity: 0.9; }
`;

export const DrillHistoryList = styled.div`
  margin: 0.5rem 0 0;
  min-width: 16rem;
  max-width: 22rem;
  text-align: center;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.85em;
  line-height: 1.5;
`;

export const DrillHistoryItem = styled.div`
  opacity: ${({ $age }) => Math.max(0.18, 0.7 - $age * 0.12)};
`;
